import { LoggerType } from '../../utils/types';
import '../Styles/Logger.css';

export function Logger({ messages }: { messages: LoggerType[] }) {
    return (
        <section className='logger-wrap'>
            <h4>ERC OUTPUT CONSOLE</h4>
            <ul>
                {messages.map((message, index) => (
                    <li key={index} className={message.type === 'success' ? 'logger-success' : message.type === 'error' ? 'logger-error' : ''}>
                        {message.message}
                    </li>
                ))}
            </ul>
        </section>
    );
}
